import Box from '@mui/material/Box'
import EditIcon from '@mui/icons-material/Edit'
import IconButton from '@mui/material/IconButton'
import ConfirmDialog from '../../../specimensOverview/components/dialogs/ConfirmDialog'
import { useTranslation } from 'react-i18next'
import { type ReactElement } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { useFormatDate } from '../../../../utils/date'

type Props = {
  name: string
  value?: string
  editableData?: {
    DialogContent: ReactElement
    fieldName: string
    saveChange: () => boolean | Promise<boolean>
    onOpen?: () => void
    isMutationMark?: boolean
    changeShouldNotAffectSpecimen?: boolean
  }
  type?: 'TEXT' | 'DATE' | 'NUMBER' | 'SELECT'
  selectOptions?: { key: string; value: string }[]
}

const LockedInputDataItem = ({
  name,
  editableData = undefined,
  type = 'TEXT',
  selectOptions = undefined,
  ...props
}: Props) => {
  const { t } = useTranslation()
  const { formatDate } = useFormatDate()
  const { control } = useFormContext()
  const watchedValue = useWatch({ name, control })
  const value = props.value ?? watchedValue

  if (type === 'SELECT' && !selectOptions) {
    throw new Error('Type SELECT must have selectOptions filled')
  }

  return (
    <Box
      sx={{
        marginY: 1,
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      {value
        ? type === 'DATE'
          ? formatDate(value)
          : type === 'SELECT'
            ? selectOptions?.find((option) => option.key === value)?.value
            : value
        : '-'}
      {editableData && (
        <>
          <ConfirmDialog
            title={
              t('volume_overview.editing_dialog_title') +
              ': ' +
              editableData.fieldName
            }
            description={
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'start',
                  flexDirection: 'column',
                  gap: 1,
                  width: '100%',
                }}
              >
                {editableData.DialogContent}
                {editableData.changeShouldNotAffectSpecimen
                  ? ''
                  : editableData.isMutationMark
                    ? t(
                        'volume_overview.editing_dialog_description_mutation_mark'
                      )
                    : t('volume_overview.editing_dialog_description')}
              </Box>
            }
            onConfirm={() => {
              return editableData.saveChange()
            }}
            onOpen={editableData.onOpen}
            TriggerButton={
              <IconButton sx={{ marginY: -1 }}>
                <EditIcon />
              </IconButton>
            }
            confirmLabel={t('common.confirm')}
            refuseLabel={t('common.cancel')}
          />
        </>
      )}
    </Box>
  )
}

export default LockedInputDataItem
